(function () {
    'use strict';

    angular.module('spidwebApp')
        .controller('ReferentialController', ReferentialController);

    ReferentialController.$inject = ['envService', 'spidLocales', 'countriesService', 'toastService'];

    function ReferentialController(envService, spidLocales, countriesService) {
        var viewModel = this;
        viewModel.locales = spidLocales; // default fallback

        // Try to load locales from backend endpoint
        countriesService.getLanguageDependencies()
            .then(function (data) {
                if (Array.isArray(data) && data.length) {
                    // data items expected to contain a 'locale' property
                    var unique = {};
                    data.forEach(function (item) {
                        if (item && item.locale) {
                            unique[item.locale] = true;
                        }
                    });
                    var localesFromApi = Object.keys(unique).sort(function (a, b) { return a > b ? 1 : -1; });
                    if (localesFromApi.length) {
                        viewModel.locales = localesFromApi;
                    }
                }
            })
            .catch(function (error) {
                console.error('Error when getting locales', error);
            });

        viewModel.fileTypes = [
            { value: 'STRUCTURATION', label: 'Structuration' },
            { value: 'WEBCATCHLINES', label: 'Webcatchlines' }
        ];
        viewModel.labels = {
            title: 'Referential File Upload',
            fileLabel: 'Select a Referential file:',
            typeLabel: 'Select file category:',
            uploadButton: 'Upload File',
            fileError: 'You must select a file',
            typeError: 'Please choose a file category',
            successMessage: 'Referential file uploaded successfully',
            errorMessage: 'Referential file upload failed',
            localeLabel: 'Select locale:',
            localeError: 'Please choose a locale'
        };
    }
})();
